import React from 'react'

export default function Projects() {
    return(
       <div class="mil-wrapper">
        <div id="content">
          <section class="mil-banner mil-banner-sm mb-5">
            <img src="assets/images/background/background-1.png" class="mil-bg-img mil-scale" data-value-1=".4" data-value-2="1.4" alt="Tło budynki mieszkalne." style={{ objectPosition: "top" }} />
              <div class="container">
                <div class="mil-background-grid mil-top-space"></div>
                  <div class="mil-banner-content mil-center">
                    <div class="mil-mb-90 ">
                      <img src="assets/images/logo/projects-logo.png" class="mil-mb-60" alt="Logo" />
                      <h1 class="mil-light mil-upper mil-mb-30">REALIZACJE</h1>
                    </div>
                  </div>
              </div>
            </section>

            <section>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/1.png" alt="Realizacja domu wielorodzinnego." />
                            </div>

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/2.png" alt="Budowa domu jednorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/3.png" alt="Stan surowy zamknięty domu wielorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/4.png" alt="Budowa osiedla mieszkalnego." />
                            </div>

                            <div href="project.html" class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/5.png" alt="Budowa domu jednorodzinnego od podstaw." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/6.png" alt="Stan surowy domu wielorodzinnego z przestrzenią usługową." />
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/7.png" alt="Realizacja domu wielorodzinnego." />
                            </div>

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/8.png" alt="Budowa domu jednorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/9.png" alt="Stan surowy zamknięty domu wielorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/10.png" alt="Budowa osiedla mieszkalnego." />
                            </div>

                            <div href="project.html" class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/11.png" alt="Budowa domu jednorodzinnego od podstaw." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/12.png" alt="Stan surowy domu wielorodzinnego z przestrzenią usługową." />
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/13.png" alt="Realizacja domu wielorodzinnego." />
                            </div>

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/14.png" alt="Budowa domu jednorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/15.png" alt="Stan surowy zamknięty domu wielorodzinnego." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/16.png" alt="Budowa osiedla mieszkalnego." />
                            </div>

                            <div href="project.html" class="mil-portfolio-item mil-square-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/17.png" alt="Budowa domu jednorodzinnego od podstaw." />
                            </div>

                        </div>
                        <div class="col-md-6 col-lg-3">

                            <div class="mil-portfolio-item mil-long-item mil-up mil-mb-30">
                                <img src="assets/images/gallery/projects/18.png" alt="Stan surowy domu wielorodzinnego z przestrzenią usługową." />
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
       </div>
    )
}